module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "form-group margin-bottom-20"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-group-control"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "referral-share-url",
      "disabled": "disabled"
    },
    domProps: {
      "value": _vm.shareUrl
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn btn-right"
  }, [_c('button', {
    staticClass: "btn green",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.copyReferralShareUrl
    }
  }, [_vm._v("Copy")])])])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "input-group-control"
  }, [_c('textarea', {
    staticClass: "form-control",
    attrs: {
      "disabled": "disabled",
      "rows": "3",
      "id": "referral-share-iframe-code"
    }
  }, [_vm._v(_vm._s(_vm.shareEmbedCode))])]), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn btn-right"
  }, [_c('button', {
    staticClass: "btn green",
    attrs: {
      "type": "button",
      "id": "copy-iframe-btn"
    },
    on: {
      "click": _vm.copyReferralShareIframeCode
    }
  }, [_vm._v("Copy")])])]), _vm._v(" "), _c('div', [_vm._v("Copy and paste the above code into an HTML page on your website.")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "margin-bottom-5"
  }, [_c('strong', [_vm._v("Direct link to your form:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "margin-bottom-20 text-center"
  }, [_c('strong', [_c('em', [_vm._v("or")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "margin-bottom-5"
  }, [_c('strong', [_vm._v("Embed this form to a website:")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d4ded926","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/formbuilder/VueFormShareLinks.vue
// module id = 1743
// module chunks = 1